import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import type { BaseQueryPopupParams } from '@mwl/core-lib';
import { useQueryPopupOpen } from '@mwl/core-lib';
import OpenBonusIcon from '@public/assets/casino/icons/openBonus.svg';
import { Button } from '@/components/Button/Button';
import { ModalMessage } from '@/components/ModalMessage/ModalMessage';
import { useGameGoBack } from '../../CasinoGamePage.hooks';
import type { PopupBalanceBonusProps } from './BalanceBonusPopup.types';
import styles from './PopupBalanceBonus.module.scss';
const popupClasses = {
  wrapper: styles.wrapper,
  close: styles.closeButton
};
export const PopupBalanceBonus: FC<PopupBalanceBonusProps> = ({
  defaultIsShow,
  onStartLoading,
  game
}) => {
  const {
    t
  } = useTranslation('common');
  const [show, setShow] = useState(false);
  const {
    createLinkProps
  } = useQueryPopupOpen();
  const back = useGameGoBack(game);
  const handleClose = useCallback(() => {
    back();
    setShow(false);
  }, [back]);
  useEffect(() => {
    setShow(defaultIsShow);
  }, [defaultIsShow]);
  const depositLinkProps = createLinkProps({
    queryName: ('deposit' as BaseQueryPopupParams)
  });
  const handleClickProceed = () => {
    setShow(false);
    onStartLoading();
  };
  return <ModalMessage show={show} title={t('modal_message.start_game_from_bonus_balance', 'You start games from the bonus balance')} onClose={handleClose} icon={<OpenBonusIcon className={styles.icon} />} popupClasses={popupClasses} customAction={<div className={styles.actions}>
          <Button as="link" {...depositLinkProps} replace className={cn(styles.button, styles.buttonDeposit)} fontSize="lg" fontWeight="bold" size="md" fullWidth align="center" color="red" rounded>
            {t('modal_message.deposit', 'Deposit')}
          </Button>
          <Button onClick={handleClickProceed} as="button" className={cn(styles.button, styles.buttonProceed)} fontSize="lg" fontWeight="bold" size="md" fullWidth align="center" color="white" rounded>
            {t('modal_message.proceed', 'Proceed')}
          </Button>
        </div>} data-sentry-element="ModalMessage" data-sentry-component="PopupBalanceBonus" data-sentry-source-file="BalanceBonusPopup.tsx" />;
};